module.exports = {"511602001":"浓洄街道","511602002":"北辰街道","511602004":"广福街道","511602005":"万盛街道","511602006":"中桥街道","511602007":"枣山街道","511602101":"官盛镇","511602102":"协兴镇","511602103":"浓溪镇","511602104":"悦来镇","511602105":"兴平镇","511602106":"井河镇","511602107":"花桥镇","511602108":"龙台镇","511602109":"肖溪镇","511602110":"恒升镇","511602111":"石笋镇","511602112":"白市镇","511602113":"大安镇","511602121":"穿石镇","511602122":"大龙镇","511602123":"东岳镇","511602207":"龙安乡","511602208":"彭家乡","511602216":"白马乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511602.json
// module id = 2497
// module chunks = 0